import { render, staticRenderFns } from "./PostPanel.vue?vue&type=template&id=7f91f70d&scoped=true"
import script from "./PostPanel.vue?vue&type=script&lang=js"
export * from "./PostPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f91f70d",
  null
  
)

export default component.exports